<template>
	<div v-if="show" class="user-panel">
		<table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr height="100%" class="itemheader">
                <td width="30%">
                    <div class="inner-panel">
                        <div class="object-titlebox">
                            <div class="object-titlebox-left" v-t="'message.menu_key_vault'"></div>
                        </div>
                        <el-tree v-if="showTree"
                            class="key-tree"
                            :props="properties"
                            :load="loadNode"
                            lazy
                            ref="tree"
                            node-key="id"
                            default-expand-all
                            highlight-current
                            expand-on-click-node="false"
                            @node-click="handleNodeClick"
                            @node-collapse="handleNodeCollapse"
                            :render-content="renderContent">
                        </el-tree>
                    </div>
                </td>
                <td width="70%">
                    <div class="inner-panel">
                        <template v-if="aiApp == null">
                            <!-- show nothing -->
                        </template>

                        <template v-else-if="!aiApp">
                            <div class="default-message" style="padding-top: 10vh;">
                                <span v-t="'message.info_ai_app_off_key_vault'"></span><br><br>
                                <div v-if="askSupport">
                                    <span v-t="'message.info_ai_app_support_request1'"></span>
                                    <a href="https://www.buddycom.net/ja/inquiry.html" target="_blank"><span v-t="'message.info_ai_app_support_request2'"></span></a>
                                    <span v-t="'message.info_ai_app_support_request3'"></span>
                                </div>
                                <div v-else-if="guideToWebPurchase">
                                    <el-button class="dialog-ok-button" style="margin-top: 4pt; margin-bottom: 4pt" @click="$router.push('license')" v-t="'message.info_ai_app_change_plan'"></el-button>
                                </div>
                                <div v-else-if="guideToPurchaseOrigin">
                                    <span v-t="'message.info_ai_app_guide_purchase_origin'"></span>
                                </div>
                            </div>
                        </template>

                        <template v-else-if="!providerSelected">
                            <div style="padding-top:100px;text-align:center">
                                <span v-t="'message.hint_select_provider'"></span>
                            </div>
                        </template>

                        <template v-else-if="providerSelected">
                            <div class="object-titlebox">
                                <div class="object-titlebox-left">
                                    {{ getSelectedProviderName() }}
                                    <button v-if="isLineWorksSelected()" class="transparent-button" type="button" @click="showLineWorksCallbackUrlDialog()"><span class="normal-command-text" v-t="'message.action_show_callback_url'"></span></button>
                                </div>
                            </div>

                            <template v-if="selectedProviderNode.data.label !== 'AOAI'">
                                <div class="object-titlebox" >
                                    <table width="100%">
                                        <tr>
                                            <td style="width:50%;padding-left:20px;padding-top:10px;text-align:left">
                                                <span class="keyvalut-header-text" v-t="'message.item_shared_key'"></span>
                                                <el-tooltip effect="dark" placement="top-start">
                                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_shared_key')"></div>
                                                    <img style="padding-bottom: 3px;display: inline;vertical-align: middle;height: 15px;" :src="require('@/assets/icon_help.svg')"/>
                                                </el-tooltip>
                                            </td>
                                            <td style="padding-right:10px;text-align:right">
                                                <button class="transparent-button" type="button" @click="addNewLink(true)"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_shared_key'"></span></button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <table v-if="commonKeyVaultList.length > 0" style="table-layout:fixed;width:100%">
                                    <tr class="keyvalut-header-record">
                                        <td class="keyvalut-header-item" v-t="'message.item_display_name'"></td>
                                        <td class="keyvalut-header-item" v-t="'message.item_registered_date'"></td>
                                        <td class="keyvalut-header-item" v-t="'message.item_user_name'"></td>
                                        <td class="keyvalut-header-item" v-t="'message.item_token'"></td>
                                        <td v-if="isLinkTypeToken()" class="keyvalut-header-item" style="width:10%;text-align:left">
                                            <span v-t="'message.action_talk_refresh'"></span>
                                            <el-tooltip effect="dark" placement="top-start">
                                                <div slot="content" style="text-align:left" v-html="$t('message.hint_refresh_key_vault')"></div>
                                                <img style="padding-bottom: 3px;display: inline;vertical-align: middle;height: 15px;" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td v-else class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.item_target_os'"></td>
                                        <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_edit'"></td>
                                        <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_delete'"></td>
                                    </tr>
                                    <tr class="objectitem-record" v-for="keyVault in commonKeyVaultList">
                                        <td class="object-item">{{ keyVault.displayName }}</td>
                                        <td class="object-item">{{ getDisplayDateTime(keyVault.registeredDate) }}</td>
                                        <td class="object-item"> ー </td>
                                        <td class="object-item">{{ keyVault.token }}</td>
                                        <td v-if="isLinkTypeToken()" class="object-item">
                                            <button class="transparent-button" type="button" @click="updateLink(keyVault, true)"><img src="../assets/icon_load.svg"/></button>
                                        </td>
                                        <td v-else class="object-item" style="width:10%;text-align:center">
                                            {{ getTargetTypeDisplayName(keyVault.targetType) }}
                                        </td>
                                        <td class="object-item" style="width:10%;text-align:center">
                                            <button class="item-record-button" @click="showEditKeyVaultDialog(keyVault)"type="button"><img src="../assets/edit.svg"/></button>
                                        </td>
                                        <td class="object-item" style="width:10%;text-align:center">
                                            <button class="item-record-button" @click="confirmDeleteKeyVault(keyVault)"type="button"><img src="../assets/icon_delete_user.svg"/></button>
                                        </td>
                                    </tr>
                                </table>
                                <div class="object-titlebox"  >
                                    <table width="100%">
                                        <tr>
                                            <td style="width:50%;padding-left:20px;padding-top:10px;text-align:left">
                                                <span class="keyvalut-header-text" v-t="'message.item_private_key'"></span>
                                                <el-tooltip effect="dark" placement="top-start">
                                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_private_key')"></div>
                                                    <img style="padding-bottom: 3px;display: inline;vertical-align: middle;height: 15px;" :src="require('@/assets/icon_help.svg')"/>
                                                </el-tooltip>
                                            </td>
                                            <td style="padding-right:10px;text-align:right">
                                                <button class="transparent-button" type="button" @click="addNewLink(false)"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_private_key'"></span></button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <table v-if="privateKeyVaultList.length > 0" style="table-layout:fixed;width:100%">
                                    <tr class="keyvalut-header-record">
                                        <td class="keyvalut-header-item" v-t="'message.item_display_name'"></td>
                                        <td class="keyvalut-header-item" v-t="'message.item_registered_date'"></td>
                                        <td class="keyvalut-header-item" v-t="'message.item_user_name'"></td>
                                        <td class="keyvalut-header-item" v-t="'message.item_token'"></td>
                                        <td v-if="isLinkTypeToken()" class="keyvalut-header-item" style="width:10%;text-align:left">
                                            <span v-t="'message.action_talk_refresh'"/>
                                            <el-tooltip effect="dark" placement="top-start">
                                                <div slot="content" style="text-align:left" v-html="$t('message.hint_refresh_key_vault')"></div>
                                                <img style="padding-bottom: 3px;display: inline;vertical-align: middle;height: 15px;" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td v-else class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.item_target_os'"></td>
                                        <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_edit'"></td>
                                        <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_delete'"></td>
                                    </tr>
                                    <tr v-for="(keyVault, index) in privateKeyVaultList" :class="{'objectitem-record': (index<privateKeyVaultList.length-1),'objectitem-record-bottom': (index==privateKeyVaultList.length-1)}">
                                        <td class="object-item">{{ keyVault.displayName }}</td>
                                        <td class="object-item">{{ getDisplayDateTime(keyVault.registeredDate) }}</td>
                                        <td class="object-item">{{ keyVault.ownerUserName }}</td>
                                        <td class="object-item">{{ keyVault.token }}</td>
                                        <td v-if="isLinkTypeToken()" class="object-item">
                                            <button class="transparent-button" type="button" @click="updateLink(keyVault, false)"><img src="../assets/icon_load.svg"/></button>
                                        </td>
                                        <td v-else class="object-item" style="width:10%;text-align:center">
                                            {{ getTargetTypeDisplayName(keyVault.targetType) }}
                                        </td>
                                        <td class="object-item" style="width:10%;text-align:center">
                                            <button class="item-record-button" @click="showEditKeyVaultDialog(keyVault)"type="button"><img src="../assets/edit.svg"/></button>
                                        </td>
                                        <td class="object-item" style="width:10%;text-align:center">
                                            <button class="item-record-button" @click="confirmDeleteKeyVault(keyVault)"type="button"><img src="../assets/icon_delete_user.svg"/></button>
                                        </td>
                                    </tr>
                                </table>
                            </template>

                            <template v-else>
                                <div class="object-titlebox">
                                    <table width="100%">
                                        <tr>
                                            <td style="width:50%;padding-left:20px;padding-top:10px;text-align:left">
                                                <span class="keyvalut-header-text" v-t="'message.item_chat_bot'"></span>
                                            </td>
                                            <td style="padding-right:10px;text-align:right">
                                                <button class="transparent-button" type="button" @click="addNewLink(true)"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_chat_bot'"></span></button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <table v-if="chatBotList.length > 0" style="table-layout:fixed;width:100%">
                                    <tr class="keyvalut-header-record">
                                        <td class="keyvalut-header-item" v-t="'message.item_display_name'"></td>
                                        <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_select_user'"></td>
                                        <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_edit'"></td>
                                        <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_delete'"></td>
                                    </tr>
                                    <tr class="objectitem-record" v-for="chatBot in chatBotList">
                                        <td class="object-item">{{ chatBot.displayName }}</td>
                                        <td class="object-item" style="width:10%;text-align:center">
                                            <button class="item-record-button" @click="showAssignUserDialog(chatBot)" type="button"><img src="../assets/add_user.old.svg"/></button>
                                        </td>
                                        <td class="object-item" style="width:10%;text-align:center">
                                            <button class="item-record-button" @click="showEditChatBotDialog(chatBot)" type="button"><img src="../assets/edit.svg"/></button>
                                        </td>
                                        <td class="object-item" style="width:10%;text-align:center">
                                            <button class="item-record-button" @click="confirmDeleteKeyVault(chatBot)" type="button"><img src="../assets/icon_delete_user.svg"/></button>
                                        </td>
                                    </tr>
                                </table>
                            </template>
                        </template>
                    </div>
                </td>
            </tr>
        </table>
        <DeleteObject v-if="showDeleteObject" :confirmInfo="confirmInfo" @delete="deleteKeyVault" @cancel="showDeleteObject=false"></DeleteObject>
        <EditKeyVault v-if="showEditKeyVault" :keyVault="targetKeyVault" @save="modifyKeyVault" @cancel="showEditKeyVault=false"></EditKeyVault>
        <AddKeyVault v-if="showAddKeyVault" :appData="appData" :keyVault="targetKeyVault" :commonKeyVaultList="commonKeyVaultList" :privateKeyVaultList="privateKeyVaultList" @save="addKeyVault" @cancel="showAddKeyVault=false"></AddKeyVault>
        <AddLineWorksV2KeyVault v-if="showAddLineWorksV2KeyVault" :appData="appData" :keyVault="targetKeyVault" @save="addLineWorksV2KeyVault" @cancel="showAddLineWorksV2KeyVault=false"></AddLineWorksV2KeyVault>
        <EditLineWorksV2KeyVault v-if="showEditLineWorksV2KeyVault" :appData="appData" :keyVault="targetKeyVault" @save="modifyLineWorksV2KeyVault" @cancel="showEditLineWorksV2KeyVault=false"></EditLineWorksV2KeyVault>
        <LineWorksCallbackUrl v-if="showLineWorksCallbackUrl" :appData="appData" @cancel="showLineWorksCallbackUrl=false"></LineWorksCallbackUrl>
        <AddAoaiKeyVault v-if="showAddAoaiKeyVault" @save="addAoaiKeyVault" @cancel="showAddAoaiKeyVault=false"></AddAoaiKeyVault>
        <EditAoaiKeyVault v-if="showEditAoaiKeyVault" :keyVault="targetKeyVault" @save="modifyAoaiKeyVault" @cancel="showEditAoaiKeyVault=false"></EditAoaiKeyVault>
        <AssignUser v-if="showAssignUser" :chatBot="targetKeyVault" :assignedUserList="chatBotAssignedUserList" :tenantId="this.appData.tenantList[0].tenantId" @save="assignUserToChatBot" @cancel="showAssignUser=false"></AssignUser>
    </div>
</template>

<script>
import server from "./ServerApi.js";
import DeleteObject from "./DeleteObject.vue";
import EditKeyVault from "./EditKeyVault.vue";
import AddKeyVault from "./AddKeyVault.vue";
import AddLineWorksV2KeyVault from "./AddLineWorksV2KeyVault.vue";
import EditLineWorksV2KeyVault from "./EditLineWorksV2KeyVault.vue";
import LineWorksCallbackUrl from "./LineWorksCallbackUrl.vue";
import AddAoaiKeyVault from "./pc/key/thirdai/AddAoaiKeyVault.vue";
import EditAoaiKeyVault from "./pc/key/thirdai/EditAoaiKeyVault.vue";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import AssignUser from "./pc/key/thirdai/AssignUser.vue";

export default {
    data () {
        return {
            show: true,
            showTree: true,
            showDeleteObject: false,
            showEditKeyVault: false,
            showAddKeyVault: false,
            showAddLineWorksV2KeyVault: false,
            showEditLineWorksV2KeyVault: false,
            showAddAoaiKeyVault: false,
            showEditAoaiKeyVault: false,
            showDeleteAoaiKeyVault: false,
            showLineWorksCallbackUrl: false,
            showAssignUser: false,
            selectedServiceType: null,
            commonKeyVaultList: [],
            privateKeyVaultList: [],
            chatBotList: [],
            providerSelected: false,
            selectedProviderNode: null,
            properties: {
                label: 'label',
                isLeaf: 'isLeaf'
            },
            targetKeyVault: null,
            confirmInfo: {
                objectName: null,
                objectTitle: null,
                isChatBot: false,
            },
            timerObjForShare: null,
            timerObjForPrivate: null,
            aiApp: null,
            tenantApps: null,
            guideToWebPurchase: false,
            guideToPurchaseOrigin: false,
            askSupport: false,
            chatBotAssignedUserList: [],
        };
    },
    methods: {
        loadNode(node, resolve) {
            var data = [];
            let keySetting = null
            if (node.parent == null) {
                keySetting = {
                                        type: 1,
                                        id: constants.VAULT_SERVICE_STORAGE + "-0",
                                        serviceId: constants.VAULT_SERVICE_STORAGE,
                                        providerName: '0',
                                        targetType: 0,
                                        label: commonUtil.getMessageText(this.$i18n,"item_storage_service"),
                                        icon: require("../assets/icon_level.svg"),
                                        isLeaf: false,
                                    };
                data.push(keySetting);
                keySetting = {
                                        type: 1,
                                        id: constants.VAULT_SERVICE_CLIENT + "-0",
                                        serviceId: constants.VAULT_SERVICE_CLIENT,
                                        providerName: '0',
                                        targetType: 0,
                                        label: "クライアント機能",
                                        icon: require("../assets/icon_level.svg"),
                                        isLeaf: false,
                                    };
                data.push(keySetting);
                keySetting = {
                                        type: 1,
                                        id: constants.VAULT_SERVICE_SNS + "-0",
                                        serviceId: constants.VAULT_SERVICE_SNS,
                                        providerName: '0',
                                        targetType: 0,
                                        label: "SNS",
                                        icon: require("../assets/icon_level.svg"),
                                        isLeaf: false,
                                    };
                data.push(keySetting);
                keySetting = {
                                        type: 1,
                                        id: constants.VAULT_SERVICE_AI + "-0",
                                        serviceId: constants.VAULT_SERVICE_AI,
                                        providerName: '0',
                                        targetType: 0,
                                        label: "AI",
                                        icon: require("../assets/icon_level.svg"),
                                        isLeaf: false,
                                    };
                data.push(keySetting);
                resolve(data);
            } else {
                switch(node.data.id) {
                    case constants.VAULT_SERVICE_STORAGE + "-0":
                        keySetting = {
                                                type: 2,
                                                id: constants.VAULT_SERVICE_STORAGE + "-" + constants.VAULT_PROVIDER_NAME_DROPBOX,
                                                serviceId: constants.VAULT_SERVICE_STORAGE,
                                                providerName: constants.VAULT_PROVIDER_NAME_DROPBOX,
                                                targetType: constants.VAULT_TARGET_TYPE_GENERAL,
                                                label: "Dropbox",
                                                icon: 'https://aldio-public.s3-ap-northeast-1.amazonaws.com/web_icon/mark_dropbox.svg',
                                                isLeaf: true,
                                            };
                        data.push(keySetting);
                        keySetting = {
                                                type: 2,
                                                id: constants.VAULT_SERVICE_STORAGE + "-" + constants.VAULT_PROVIDER_NAME_BOX,
                                                serviceId: constants.VAULT_SERVICE_STORAGE,
                                                providerName: constants.VAULT_PROVIDER_NAME_BOX,
                                                targetType: constants.VAULT_TARGET_TYPE_GENERAL,
                                                label: "Box",
                                                icon: 'https://aldio-public.s3-ap-northeast-1.amazonaws.com/web_icon/mark_box.png',
                                                isLeaf: true,
                                            };
                        data.push(keySetting);
/*                        keySetting = {
                                                type: 2,
                                                id: constants.VAULT_SERVICE_STORAGE + "-" + constants.VAULT_PROVIDER_NAME_GOOGLE,
                                                serviceId: constants.VAULT_SERVICE_STORAGE,
                                                providerName: constants.VAULT_PROVIDER_NAME_GOOGLE,
                                                targetType: constants.VAULT_TARGET_TYPE_GENERAL,
                                                label: "Google Drive",
                                                icon: 'https://aldio-public.s3-ap-northeast-1.amazonaws.com/web_icon/mark_google_drive.png',
                                                isLeaf: true,
                                            };
                        data.push(keySetting);
                        keySetting = {
                                                type: 2,
                                                id: constants.VAULT_SERVICE_STORAGE + "-" + constants.VAULT_PROVIDER_NAME_MICROSOFT,
                                                serviceId: constants.VAULT_SERVICE_STORAGE,
                                                providerName: constants.VAULT_PROVIDER_NAME_MICROSOFT,
                                                targetType: constants.VAULT_TARGET_TYPE_GENERAL,
                                                label: "OneDrive",
                                                icon: 'https://aldio-public.s3-ap-northeast-1.amazonaws.com/web_icon/mark_one_drive.png',
                                                isLeaf: true,
                                            };
                        data.push(keySetting);*/
                        break;
                    case constants.VAULT_SERVICE_CLIENT + "-0":
                        keySetting = {
                                                type: 2,
                                                id: constants.VAULT_SERVICE_CLIENT + "-" + constants.VAULT_PROVIDER_NAME_SCANDIT,
                                                serviceId: constants.VAULT_SERVICE_CLIENT,
                                                providerName: constants.VAULT_PROVIDER_NAME_SCANDIT,
                                                targetType: 0,
                                                label: "Scandit",
                                                icon: require("../assets/scandit.png"),
                                                isLeaf: true,
                                            };
                        data.push(keySetting);
                        break;
                    case constants.VAULT_SERVICE_SNS + "-0":
                        keySetting = {
                                                type: 2,
                                                id: constants.VAULT_SERVICE_SNS + "-" + constants.VAULT_PROVIDER_NAME_WORKS_MOBILE_V2,
                                                serviceId: constants.VAULT_SERVICE_SNS,
                                                providerName: constants.VAULT_PROVIDER_NAME_WORKS_MOBILE_V2,
                                                targetType: 0,
                                                label: "LINE WORKS API 2.0",
                                                icon: 'https://aldio-public.s3-ap-northeast-1.amazonaws.com/web_icon/mark_LineWorks.svg',
                                                isLeaf: true,
                                            };
                        data.push(keySetting);
                        break;
                    case constants.VAULT_SERVICE_AI + "-0":
                        keySetting = {
                                                type: 2,
                                                id: constants.VAULT_SERVICE_AI + "-" + constants.VAULT_PROVIDER_NAME_AOAI,
                                                serviceId: constants.VAULT_SERVICE_AI,
                                                providerName: constants.VAULT_PROVIDER_NAME_AOAI,
                                                targetType: 0,
                                                label: "AOAI",
                                                icon: require("../assets/assistant.svg"),
                                                isLeaf: true,
                                            };
                        data.push(keySetting);
                        break;
                }
                resolve(data);
            }
        },
        renderContent(h, { node, data, store }) {
            return h("span", [h("img", { attrs: { src: data.icon ,width: "20px", style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        handleNodeClick(data, node, elNode) {
            if (!this.aiApp) {
                // do nothing
                return;
            }
            switch(node.data.type) {
                case 1:
                    this.providerSelected = false;
                    break;
                case 2:
                    this.providerSelected = true;
                    if (this.selectedProviderNode != null) {
                        if (node.data.serviceId == constants.VAULT_SERVICE_STORAGE) {
                            if ((this.selectedProviderNode.data.serviceId != node.data.serviceId) || (this.selectedProviderNode.data.providerName != node.data.providerName)) {
                                // check oAuth2 state when selected provider was changed.
                                this.getOAuth2RegistrationState(node.data.serviceId, node.data.providerName, true);
                                this.getOAuth2RegistrationState(node.data.serviceId, node.data.providerName, false);
                            }
                        } else if(node.data.serviceId == constants.VAULT_SERVICE_AI){
                            if ((this.selectedProviderNode.data.serviceId != node.data.serviceId) || (this.selectedProviderNode.data.providerName != node.data.providerName)) {
                                this.getThirdAiChatBotList()
                            }
                        } else {
                            if ((this.selectedProviderNode.data.serviceId != node.data.serviceId) || (this.selectedProviderNode.data.providerName != node.data.providerName)) {
                                this.getKeyListOfProvider(node.data.serviceId, node.data.providerName, null);
                            }
                        }
                    } else {
                        this.getKeyListOfProvider(node.data.serviceId, node.data.providerName, null);
                        this.getThirdAiChatBotList()
                    }
                    this.selectedProviderNode = node;
                    break;
            }
        },
        getKeyListOfProvider(serviceId, providerName, sharedType) {
            let self = this;
            this.commonKeyVaultList = [];
            this.privateKeyVaultList = [];
            this.chatBotList = [];
            server.postNoError('/getkeyvaultlist', { serviceId: serviceId, providerName: providerName, sharedType: sharedType })
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        for (let keyVault of res.data.keyVaultList) {
                            if (keyVault.ownerUserId == 0) {
                                self.commonKeyVaultList.push(keyVault);
                            } else {
                                self.privateKeyVaultList.push(keyVault);
                            }
                        }
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getkeyvaultlist").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getkeyvaultlist", error);
            });
        },
        getOAuth2RegistrationState(serviceId, providerName, sharedType) {
            if (sharedType) {
                clearInterval(this.timerObjForShare);
                this.timerObjForShare = null;
            } else {
                clearInterval(this.timerObjForPrivate);
                this.timerObjForPrivate = null;
            }
            let self = this;
            server.postNoError('/getoauth2state', { serviceId: serviceId, providerName: providerName, sharedType: sharedType })
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        // OAuth2 still processing.
                        if (sharedType) {
                            self.timerObjForShare = setInterval(function() {self.getOAuth2RegistrationState(serviceId, providerName, sharedType)}, 1000);
                        } else {
                            self.timerObjForPrivate = setInterval(function() {self.getOAuth2RegistrationState(serviceId, providerName, sharedType)}, 1000);
                        }
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        // OAuth2 has processed. (Refresh key list of provider)
                        self.getKeyListOfProvider(serviceId, providerName, sharedType);
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getOAuth2RegistrationState").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getOAuth2RegistrationState", error);
            });
        },
        getThirdAiChatBotList(serviceId, providerName, sharedType) {
            this.commonKeyVaultList = [];
            this.privateKeyVaultList = [];
            this.chatBotList = [];
            server.postNoError('/getthirdaichatbotlist', {serviceId: serviceId, providerName: providerName, sharedType: sharedType})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            for(let chatBot of res.data.chatBotList) {
                                this.chatBotList.push(chatBot);
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getThirdAiChatBotList").replace("{code}", res.data.status));
                            break;
                    }
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(this, "getThirdAiChatBotList", error);
                });
        },
        addNewLink(sharedType) {
            if (!this.isEnableToAddKey(this.selectedProviderNode.data.serviceId, sharedType)) {
                return;
            }
            if ((sharedType) && (!this.appData.tenantAdminUser) && (this.selectedProviderNode.data.serviceId !== constants.VAULT_SERVICE_AI)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_shared_key"));
                return;
            } else if ((!this.appData.tenantAdminUser) && (this.selectedProviderNode.data.serviceId === constants.VAULT_SERVICE_AI)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_chatbot"));
                return;
            }
            if (this.selectedProviderNode.data.serviceId == constants.VAULT_SERVICE_SNS && this.selectedProviderNode.data.providerName == constants.VAULT_PROVIDER_NAME_WORKS_MOBILE_V2) {
                this.targetKeyVault = this.selectedProviderNode.data;
                this.targetKeyVault.sharedType = sharedType;
                this.showAddLineWorksV2KeyVault = true;
                return;
            }
            switch(this.selectedProviderNode.data.serviceId) {
                case constants.VAULT_SERVICE_STORAGE:
                    let param = {
                                    sharedType: sharedType,
                                    serviceId: this.selectedProviderNode.data.serviceId,
                                    providerName: this.selectedProviderNode.data.providerName,
                                    doLinkingAnyway: false
                                };
                    this.doOAuthLink(param);
                    break;
                case constants.VAULT_SERVICE_CLIENT:
                    this.targetKeyVault = this.selectedProviderNode.data;
                    this.targetKeyVault.sharedType = sharedType;
                    this.showAddKeyVault = true;
                    break;
                case constants.VAULT_SERVICE_AI:
                    if (this.chatBotList.length >= constants.MAX_CHATBOT_COUNT) {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_exceeds_max_chat_bot"));
                        return;
                    }
                    this.targetKeyVault = this.selectedProviderNode.data;
                    this.targetKeyVault.sharedType = sharedType;
                    this.showAddAoaiKeyVault = true;
                    break;
            }
        },
        updateLink(keyVault, sharedType) {
            if (sharedType) {
                if (!this.appData.tenantAdminUser) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_shared_key"));
                    return;
                }
            } else {
                if (keyVault.ownerUserId != this.appData.loginUserObjectId) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_private_key"));
                    return;
                }
            }
            let param = {
                            sharedType: sharedType,
                            serviceId: keyVault.serviceId,
                            providerName: keyVault.providerName,
                            targetType: keyVault.targetType,
                            doLinkingAnyway: true,
                        }
            this.doOAuthLink(param);
        },
        doOAuthLink(param) {
            let self = this;
            server.post('/setoauth2link', param )
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (param.sharedType) {
                            self.timerObjForShare = setInterval(function() { self.getOAuth2RegistrationState(param.serviceId, param.providerName, param.sharedType)}, 1000);
                        } else {
                            self.timerObjForPrivate = setInterval(function() { self.getOAuth2RegistrationState(param.serviceId, param.providerName, param.sharedType)}, 1000);
                        }
                        this.$root.store.needRefreshOfProcessorTemplate = true;
                        window.open(res.data.redirectUri, '_blank', 'width=500,height=600');
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n,"error_cannot_key_vault_already_registered"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","setOAuth2Link").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "doOAuthLink", error);
            });
        },
        showEditKeyVaultDialog(keyVault) {
            this.targetKeyVault = keyVault;
            if ((keyVault.serviceId == constants.VAULT_SERVICE_SNS) && (keyVault.providerName == constants.VAULT_PROVIDER_NAME_WORKS_MOBILE_V2)) {
                this.showEditLineWorksV2KeyVault = true;
                return;
            }
            this.showEditKeyVault = true;
        },

        showEditChatBotDialog(chatBot) {
            this.targetKeyVault = chatBot;
            if (!this.appData.tenantAdminUser){
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_chatbot"));
                return;
            }

            server.post('/getthirdaichatbot', {id: chatBot.id})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.targetKeyVault.id = res.data.id;
                            this.targetKeyVault.displayName = res.data.info.displayName;
                            this.targetKeyVault.endpoint = res.data.info.endpoint;
                            this.targetKeyVault.apiKey = res.data.info.apiKey;
                            this.targetKeyVault.pluginId = res.data.info.pluginId;
                            this.targetKeyVault.modelKey = res.data.info.modelKey;
                            this.targetKeyVault.systemPrompt = res.data.info.systemPrompt;
                            this.targetKeyVault.ignoreWords = res.data.info.ignoreWords;
                            this.showEditAoaiKeyVault = true;
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getThirdAiChatBot").replace("{code}", res.data.status));
                            break;
                    }
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(this, "getThirdAiChatBot", error);
                });
        },

        showAssignUserDialog(chatBot) {
            this.targetKeyVault = chatBot;
            if (!this.appData.tenantAdminUser){
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_assign_user_to_chat_bot"));
                return;
            }
            server.post('/fetchassistantuser', {chatBotId: chatBot.id})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.chatBotAssignedUserList = res.data.userList;
                            this.showAssignUser = true;
                            break;
                        default:
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchAssistantUser").replace("{code}", res.data.status));
                            break;
                    }
                })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(this, "fetchAssistantUser", error);
                });
        },

        addLineWorksV2KeyVault(input) {
            this.showAddLineWorksV2KeyVault = false;
            let requestParam = {
                displayName:    input.inputForm.displayName.value,
                clientId:       input.inputForm.clientId.value,
                clientSecret:   input.inputForm.clientSecret.value,
                serviceAccount: input.inputForm.serviceAccount.value,
                botName:        input.inputForm.botName.value,
                botId:          input.inputForm.botId.value,
                botSecret:      input.inputForm.botSecret.value,
                sharedType:     input.sharedType,
            };
            let secretFile = input.secretFile;
            let self = this;
            server.postWithFile("/addlineworksv2keyvault", secretFile, JSON.stringify(requestParam))
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getKeyListOfProvider(self.targetKeyVault.serviceId, self.targetKeyVault.providerName, null);
                            if (input.sharedType) {
                                commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_shared_key")));
                            } else {
                                commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_private_key")));
                            }
                            self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(this.$i18n,"error_line_works_invalid_parameter"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addLineWorksV2KeyVault").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "addLineWorksV2KeyVault", error);
                });
        },
        addKeyVault(input) {
            this.showAddKeyVault = false;
            let self = this;
            server.post('/addkeyvault', {
                sharedType: input.sharedType,
                serviceId: input.serviceId,
                providerName: input.providerName,
                targetType: input.targetType,
                displayName: input.displayName,
                tokenType: input.tokenType,
                token: input.token
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.getKeyListOfProvider(self.targetKeyVault.serviceId, self.targetKeyVault.providerName, null);
                        if (input.sharedType) {
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_shared_key")));
                        } else {
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_private_key")));
                        }
                        self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addKeyVault").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "addKeyVault", error);
            });
        },

        addAoaiKeyVault(input) {
            this.showAddAoaiKeyVault = false;
            let self = this;
            server.post('/addthirdaichatbot', {
                displayName: input.displayName,
                endpoint: input.endpoint,
                apiKey: input.apiKey,
                pluginId: input.pluginId,
                modelKey: input.modelKey,
                systemPrompt: input.systemPrompt,
                ignoreWords: input.ignoreWords,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.getThirdAiChatBotList()
                        commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_chat_bot_modified"));
                        self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n,"error_cannot_create_user_insufficient_option"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n, "error_exceeds_max_chat_bot"));
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n, "error_chat_bot_add_already_registered"));
                        break;
                    default:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "addAoaiKeyVault").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(self, "addKeyVault", error);
            });
        },

        modifyLineWorksV2KeyVault(input) {
            this.showEditLineWorksV2KeyVault = false;
            let requestParam = {
                ownerUserId: input.ownerUserId,
            };
            for (let key in input.inputForm) {
                let value = input.inputForm[key].value;
                if (!value) {
                    continue;
                }
                requestParam[key] = value;
            }
            let secretFile = input.secretFile;
            let self = this;
            server.postWithFile("/addlineworksv2keyvault", secretFile, JSON.stringify(requestParam))
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getKeyListOfProvider(self.targetKeyVault.serviceId, self.targetKeyVault.providerName, null);
                            if (input.ownerUserId == 0) {
                                commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_shared_key")));
                            } else {
                                commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_private_key")));
                            }
                            self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(this.$i18n,"error_line_works_invalid_parameter"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyLineWorksV2KeyVault").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "modifyLineWorksV2KeyVault", error);
                });
        },
        modifyKeyVault(input) {
            this.showEditKeyVault = false;
            let param = {
                    ownerUserId: this.targetKeyVault.ownerUserId,
                    serviceId: this.targetKeyVault.serviceId,
                    providerName: this.targetKeyVault.providerName,
                    targetType: this.targetKeyVault.targetType,
            };
            if (this.targetKeyVault.serviceId == constants.VAULT_SERVICE_STORAGE) {
                if (this.targetKeyVault.displayName == input.newName) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_change_information"));
                    return;
                }
                param.newDisplayName = input.newName
            } else {
                if ((this.targetKeyVault.displayName == input.newName) && (this.targetKeyVault.token == input.newToken)) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_change_information"));
                    return;
                }
                param.newDisplayName = input.newName
                param.newToken = input.newToken
            }
            let self = this;
            server.post('/modifykeyvault', param )
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.getKeyListOfProvider(self.targetKeyVault.serviceId, self.targetKeyVault.providerName, null);
                        if (self.targetKeyVault.ownerUserId == 0) {
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_shared_key")));
                        } else {
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_modified").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_private_key")));
                        }
                        self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyKeyVault").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyKeyVault", error);
            });
        },

        modifyAoaiKeyVault(input) {
            this.showEditAoaiKeyVault = false;
            let self = this;
            server.post('/modifythirdaichatbot', {
                id: this.targetKeyVault.id,
                info: {
                    displayName: input.displayName,
                    endpoint: input.endpoint,
                    apiKey: input.apiKey,
                    pluginId: input.pluginId,
                    modelKey: input.modelKey,
                    systemPrompt: input.systemPrompt,
                    ignoreWords: input.ignoreWords,
                },
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.getThirdAiChatBotList();
                        commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_chat_bot_modified"));
                        self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n, "error_chat_bot_modify_already_registered"));
                        break;
                    default:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "modifyAoaiKeyVault").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(self, "modifyAoaiKeyVault", error);
            });
        },

        confirmDeleteKeyVault(keyVault) {
            if (keyVault.ownerUserId == 0) {
                if (!this.appData.tenantAdminUser) {
                    if (this.selectedProviderNode.data.serviceId === constants.VAULT_SERVICE_AI){
                        commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_cannot_delete_chatbot"));
                        return;
                    }

                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_cannot_delete_shared_key"));
                    return;
                }
            } else {
                if ((keyVault.ownerUserId != this.appData.loginUserObjectId) && (!this.appData.tenantAdminUser)) {
                    if (this.selectedProviderNode.data.serviceId === constants.VAULT_SERVICE_AI){
                        commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_cannot_delete_chatbot"));
                        return;
                    }
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_cannot_delete_other_users_key"));
                    return;
                }
            }
            this.targetKeyVault = keyVault;
            this.confirmInfo.objectName = keyVault.displayName;
            this.confirmInfo.objectTitle = this.getKeyVaultObjectName(keyVault);
            this.confirmInfo.isChatBot = this.selectedProviderNode.data.serviceId === constants.VAULT_SERVICE_AI;
            this.showDeleteObject = true;
        },

        deleteKeyVault() {
            this.showDeleteObject = false;
            if(this.selectedProviderNode.data.serviceId === constants.VAULT_SERVICE_AI){
                this.deleteChatBot();
                return;
            }
            let self = this;
            server.post('/deletekeyvault', {
                ownerUserId: this.targetKeyVault.ownerUserId,
                serviceId: this.targetKeyVault.serviceId,
                providerName: this.targetKeyVault.providerName,
                tokenType: this.targetKeyVault.tokenType,
                targetType: this.targetKeyVault.targetType
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.getKeyListOfProvider(self.targetKeyVault.serviceId, self.targetKeyVault.providerName, null);
                        if (self.targetKeyVault.ownerUserId == 0) {
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_deleted").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_shared_key")));
                        } else {
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n,"info_key_vault_deleted").replace("{keyType}",commonUtil.getMessageText(self.$i18n,"item_private_key")));
                        }
                        self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(this.$i18n,"error_key_vault_already_deleted"));
                        break;
                    case constants.STATUS_ERROR_STILL_ASSIGNED:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(this.$i18n,"error_cannot_remove_key_vault_still_assigned"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","deleteKeyVault").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "deleteKeyVault", error);
            });
        },

        deleteChatBot() {
            this.showDeleteObject = false;
            let self = this;
            server.post('/deletethirdaichatbot', {
                id: this.targetKeyVault.id,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.getThirdAiChatBotList()
                        commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_chat_bot_modified"));
                        self.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
                        break;
                    default:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "deleteChatBot").replace("{code}", res.data.status));
                        break;
                }
            })
            .catch(function (error) {
                commonUtil.putExceptionErrorMessage(self, "deleteChatBot", error);
            });
        },

        getSelectedProviderName() {
            let serviceName = null;
            switch(this.selectedProviderNode.data.serviceId) {
                case constants.VAULT_SERVICE_STORAGE:
                    serviceName = commonUtil.getMessageText(this.$i18n,"item_storage_service");
                    break;
                case constants.VAULT_SERVICE_CLIENT:
                    serviceName = "クライアント機能";
                    break;
                case constants.VAULT_SERVICE_SNS:
                    serviceName = "SNS";
                    break;
                case constants.VAULT_SERVICE_AI:
                    serviceName = "AI";
            }
            return serviceName + "（" + this.selectedProviderNode.data.label + ")";
        },
        isLineWorksSelected() {
            let providerName = this.selectedProviderNode.data.providerName
            return providerName == constants.VAULT_PROVIDER_NAME_WORKS_MOBILE_V2
        },
        getKeyVaultObjectName(keyVault) {
            let objectName = this.selectedProviderNode.data.label;
            if (keyVault.ownerUserId == 0) {
                return commonUtil.getMessageText(this.$i18n,"title_key_vault_shared_key").replace("{provider}",objectName);
            } else {
                return commonUtil.getMessageText(this.$i18n,"title_key_vault_private_key").replace("{provider}",objectName);
            }
        },
        getDisplayDateTime(datetime) {
            return new Date(datetime).toLocaleString();
        },
        getTargetTypeDisplayName(targetType) {
            switch(targetType) {
                case constants.VAULT_TARGET_TYPE_GENERAL:
                    return "汎用";
                    break;
                case constants.VAULT_TARGET_TYPE_ANDROID:
                    return "Android";
                    break;
                case constants.VAULT_TARGET_TYPE_IOS:
                    return "iOS";
                    break;
            }
        },
        isLinkTypeToken() {
            if (this.selectedProviderNode.data.serviceId == constants.VAULT_SERVICE_STORAGE) {
                return true;
            } else {
                return false;
            }
        },
        isEnableToAddKey(serviceId, sharedType) {
            let existKeyCount = 0;
            if (sharedType) {
                existKeyCount = this.commonKeyVaultList.length;
            } else {
                for (let keyVault of this.privateKeyVaultList) {
                    if (keyVault.ownerUserId == this.appData.loginUserObjectId) {
                        existKeyCount++;
                    }
                }
            }

            let maxKeyCount = 1;
            if (serviceId == constants.VAULT_SERVICE_CLIENT) {
                maxKeyCount = 2;
            }

            if (sharedType) {
                if (existKeyCount >= maxKeyCount) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_shared_key_exist"));
                    return false;
                }
            } else {
                if (existKeyCount >= maxKeyCount) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_private_key"));
                    return false;
                }
            }
            return true;
        },
        showLineWorksCallbackUrlDialog() {
            this.showLineWorksCallbackUrl = true;
        },
        getAiAppInformation() {
            let self = this;
            server.post('/getaiappinformation', {})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.aiApp = res.data.aiApp;
                            if (res.data.aiApp) {
                                return;
                            }
                            switch (res.data.planType) {
                                // Lite plans or old standard plan
                                case constants.LICENSE_PLAN_TALK_LITE:
                                case constants.LICENSE_PLAN_LIVE_LITE:
                                case constants.LICENSE_PLAN_LITE:
                                case constants.LICENSE_PLAN_STANDARD:
                                    if (res.data.webTenant) {
                                        self.guideToWebPurchase = true;
                                    } else {
                                        self.guideToPurchaseOrigin = true;
                                    }
                                    break;

                                // Enterprise plans but OFF: ask support
                                // separate plan: ask support
                                case constants.LICENSE_PLAN_TALK_ENT:
                                case constants.LICENSE_PLAN_LIVE_ENT:
                                case constants.LICENSE_PLAN_ENTERPRISE:
                                case constants.LICENSE_PLAN_SEPARATE:
                                    self.askSupport = true;
                                    break;
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getAiAppInformation").replace("{code}",res.data.status));
                            break;
                    }

                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getAiAppInformation", error);
                });
        },
        assignUserToChatBot(input) {
            this.showAssignUser = false;
            let addIdList = [];
            let removeIdList = [];

            for (let key in input.addTagList) {
                addIdList.push(input.addTagList[key].id);
            }

            for (let key in input.removeTagList) {
                removeIdList.push(input.removeTagList[key].id);
            }

            let self = this;
            server.post('/updateassistantuser', {
                chatBotId: this.targetKeyVault.id,
                addIdList: addIdList,
                removeIdList: removeIdList,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_updated_assistant_user"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n, "error_exceeds_max_assistant_user"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT_ONCE:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n, "error_exceeds_max_assistant_user_once"));
                        break;
                    default:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "assignUserToChatBot").replace("{code}", res.data.status));
                        break;
                }
            })
                .catch(function (error) {
                    commonUtil.putExceptionErrorMessage(self, "assignUserToChatBot", error);
                });
        },
        getAppsOfThisTenant() {
            let self = this;
            server.post('/gettenantapps')
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.tenatnApps = res.data.apps;

                        this.$refs.tree.store.nodesMap[constants.VAULT_SERVICE_AI + "-0"].visible = self.tenatnApps & constants.AOAI;
                        this.$refs.tree.store.nodesMap[constants.VAULT_SERVICE_AI + "-" + constants.VAULT_PROVIDER_NAME_AOAI].visible = self.tenatnApps & constants.AOAI;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "mounted", error);
                });
        },
    },
    watch: {
        '$route' (to, from) {
            if (from.name == "KeyVault") {
                if (this.timerObjForShare != null) {
                    clearInterval(this.timerObjForShare);
                    this.timerObjForShare = null;
                }
                if (this.timerObjForPrivate != null) {
                    clearInterval(this.timerObjForPrivate);
                    this.timerObjForPrivate = null;
                }
            } else if (to.name == "KeyVault") {
                this.getAiAppInformation();
            }
        }
    },
    components: {
        AssignUser,
        DeleteObject,
        EditKeyVault,
        AddKeyVault,
        AddLineWorksV2KeyVault,
        EditLineWorksV2KeyVault,
        LineWorksCallbackUrl,
        AddAoaiKeyVault,
        EditAoaiKeyVault
    },
    created: function() {
        this.getAiAppInformation();
        this.getAppsOfThisTenant();
    },
    props: ['appData']
}
</script>

<style>
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ecf1fa !important;
}
.el-tree-node > .el-tree-node__content:hover {
    background-color: #ecf1fa !important;
}
.el-tree-node__content {
    height: 40px !important;
}
.el-tree-node__content img {
    margin-left: -20px !important;
    padding-right: 8px !important;
}
.el-tree-node__expand-icon {
    padding: 28px !important;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inner-panel {
	position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
	background-color: #ffffff;
}

.key-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.key-tree.el-tree {
    overflow: auto;
}
.key-tree.el-tree {
    width: 100%;
    height: calc(100vh - 120px);
}

.keyvalut-header-record {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.keyvalut-header-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.keyvalut-header-text {
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
}

</style>
